import api from './api';

// Servicio de salidas
export const exitsService = {
  // Obtener todas las salidas con paginación
  getAll: async (page = 1, limit = 40, search = '', startDate = '', endDate = '', company = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
      });
      
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (company) params.append('company', company);
      
      const response = await api.get(`/exits?${params.toString()}`);
      return response.data; // Retorna { success, data, pagination }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo salidas');
    }
  },

  // Obtener salida por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/exits/${id}`);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo salida');
    }
  },

  // Crear nueva salida
  create: async (exitData) => {
    try {
      const response = await api.post('/exits', exitData);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error creando salida');
    }
  },

  // Actualizar salida
  update: async (id, exitData) => {
    try {
      const response = await api.put(`/exits/${id}`, exitData);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando salida');
    }
  },

  // Eliminar salida
  delete: async (id) => {
    try {
      const response = await api.delete(`/exits/${id}`);
      return response.data; // El delete puede retornar solo success
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error eliminando salida');
    }
  },

  // Obtener resumen de salidas
  getSummary: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      const response = await api.get('/exits/reports/summary', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo resumen de salidas');
    }
  },

  // Actualizar imagen de requisición
  updateImage: async (id, imageFileName) => {
    try {
      const response = await api.put(`/exits/${id}/image`, {
        requisition_image: imageFileName
      });
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando imagen de requisición');
    }
  },

  // Actualizar fotos de entrega
  updateDeliveryPhotos: async (id, photos) => {
    try {
      const response = await api.put(`/exits/${id}/delivery-photos`, {
        delivery_photos: photos
      });
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando fotos de entrega');
    }
  },

  // Obtener salidas por producto
  getByProductId: async (productId) => {
    try {
      console.log('🔄 Solicitando salidas para producto ID:', productId);
      const response = await api.get(`/exits/product/${productId}`);
      console.log('📊 Respuesta del servidor (exits):', response.data);
      
      // Si la respuesta tiene estructura { success, data }
      if (response.data && response.data.success && response.data.data) {
        // Asegurarse de que todas las cantidades sean números
        const processedData = response.data.data.map(exit => ({
          ...exit,
          quantity: parseFloat(exit.quantity) || 0
        }));
        console.log('📊 Datos procesados (exits):', processedData);
        return processedData;
      }
      
      // Si la respuesta es directamente un array
      if (Array.isArray(response.data)) {
        // Asegurarse de que todas las cantidades sean números
        const processedData = response.data.map(exit => ({
          ...exit,
          quantity: parseFloat(exit.quantity) || 0
        }));
        console.log('📊 Datos procesados (exits array):', processedData);
        return processedData;
      }
      
      // Si no reconocemos el formato, devolvemos un array vacío
      console.warn('⚠️ Formato de respuesta no reconocido en getByProductId:', response.data);
      return [];
    } catch (error) {
      console.error('❌ Error obteniendo salidas del producto:', error);
      if (error.response) {
        console.error('❌ Detalles del error:', error.response.data);
      }
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo salidas del producto');
    }
  },

  // Buscar salida por número de requisición
  getByRequisitionNumber: async (requisitionNumber) => {
    try {
      console.log('🔍 Buscando salida con requisición:', requisitionNumber);
      const response = await api.get(`/exits/by-requisition/${requisitionNumber}`);
      console.log('✅ Respuesta del servidor:', response.data);
      
      if (response.data && response.data.success && response.data.data) {
        return response.data.data;
      }
      
      return null;
    } catch (error) {
      console.error('❌ Error buscando salida por requisición:', error);
      if (error.response?.status === 404) {
        return null; // Salida no encontrada
      }
      throw new Error(error.response?.data?.error || error.message || 'Error buscando salida');
    }
  }
};

export default exitsService;
